import { productMock } from './productMock';
import { cartMock } from './cartMock';
import { placeDetailsMock, predictionsMock } from './addressMock';

export function mocksApi<T>(url: URL, options: any) {
  if (/maps\/api\/place/g.test(url.pathname)) {
    return null;
  }
  if (url.pathname === '/liquid-sessions-staging-v1') {
    return JSON.parse(options.body);
  }
  if (url.pathname === '/api/v1/liquid/tokens') {
    if (options.method === 'GET') {
      return {
        access_token: '6l1jrvsVKgdrbK7WnDDXzFrTQqDw0OWujeZ72KGIopU',
        token_type: 'Bearer',
        expires_in_left: 594450,
        expires_in: 604795,
        created_at: 1691157829,
      } as T;
    } else if (options.method === 'POST') {
      return {
        auth: '{"currentRouteKey":"elements.cart","session":"U2FsdGVkX18rWS5ZYj1z1nqqnRoHiyJHcSvgIiqjO24h7f3N1zQYLPDRB2PT9LYvEZWH/XhcR+0L82aonL5iHE1ebYjkgoZKC0Mp+6yUsQjkvl/FFJ5H7EGpVK7CfHCG8sbv8V8aeH5zQy6FhsRUS9urOLFm9Kp3QI9nwBv99rWQ+AytMckX1PCo6lGbeJWrOfrF/vypl9cJ9Ev875lbfiDkT0QwI15qBfkW/1++Ab9U1BYVOmXUi0YeW61YQDUm7/Wc7LvP829Pjvmdwtn0sg==","layoutType":"single","previousLayoutType":"","productCols":2,"token":"","secure":true,"inIframe":true,"user":{},"configs":{"text":{"headings":{"font":"Oswald","color":"#000"},"body":{"font":"Oswald","color":"#000"},"hyperlink":{"font":"Oswald","color":"#1B574D"}},"components":{"qtyElement":{"type":"-/+","active":true,"text":"#FFF","bg":"#1B574D","border":"#1B574D","btnText":"#FFF","btnBg":"#1B574D","btnBorder":"#1B574D"},"cartItem":{"imgBorder":{"active":true,"border":"#D1D"},"bg":"#1B574D11","border":"#f1f5f9"},"overlay":{"btnSave":{"text":"#FFF","bg":"#1B574D","border":"#1B574D"},"btnCancel":{"text":"#1B574D","bg":"#EF444400","border":"#1B574D"}},"alerts":{"text":"#60A5FA","bg":"#F0F9FF","border":"#F0F9FF"}},"general":{"header":{"text":"#FFF","bg":"#1B574D","border":"#1B574D","btnText":"#CCCC","btnBg":"#CCC","btnBorder":"#1B574D"},"footer":{"text":"#FFF","bg":"#1B574D","border":"#1B574D","btnText":"#CCCC","btnBg":"#CCC","btnBorder":"#1B574D"},"element":{"corners":"sharp","bg":"#FFFFFF","border":"#D1D","liquidLegal":true},"engraving":{"active":true}},"env":{"staging":["spun85ch7fo087ss-57389547682.shopifypreview.com"],"production":"spun85ch7fo087ss-57389547682.shopifypreview.com","live":true,"allowLocal":true,"trackEvents":true,"gtmKey":"","gaKey":""}},"liquidAnalytics":{"gtm":"GTM-TNJ2VF8","active":true,"ga":["G-S8XYVHFT47"],"property":"properties/376627514"},"loading":false,"productionReady":false,"liquidToken":"1a2c4633eb8e8074f73845c3c0180ef98b2c273af08668ddd6616e7f","element":"cart","view":"desktop","dynamicStyles":{"container":"925px","grid":"2","seeMore":"blur-[14px]"},"bg":"","env":{"staging":["spun85ch7fo087ss-57389547682.shopifypreview.com"],"production":"spun85ch7fo087ss-57389547682.shopifypreview.com","live":true,"allowLocal":true,"trackEvents":true,"gtmKey":"","gaKey":""}}',
        elements:
          '{"secure":true,"loading":false,"addressActive":false,"addressUpdated":false,"address":{"formattedAddress":"79 Madison Ave, New York, NY 10016, USA","address1":"79 Madison Avenue","streetNumber":"79","city":"Manhattan","latitude":40.7441619,"longitude":-73.98531249999999,"state":"NY","zipCode":"10016","placeId":"liquidDefaultAddress"},"newAddress":{},"cartId":720826}',
        _persist: '{"version":-1,"rehydrated":true}',
      } as T;
    }
  }
  if (url.hostname === 'utils.liquidcheckout.com' && url.searchParams.get('input')) {
    return predictionsMock() as T;
  }

  if (url.hostname === 'utils.liquidcheckout.com' && url.searchParams.get('placeId')) {
    return placeDetailsMock() as T;
  }

  if (url.pathname === '/api/v3/retailers/multi_select') {
    return productMock(options.body.ids) as T;
  }

  if (url.pathname.startsWith('/api/v2/cart')) {
    return cartMock(url, options) as T;
  }

  return {} as T;
}
